import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-record",
  "use": "icon-record-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-record\"><path d=\"M576 448h192v128H448V256h128v192z m-64 576c-282.7712 0-512-229.2288-512-512S229.2288 0 512 0s512 229.2288 512 512-229.2288 512-512 512z m0-128c212.0768 0 384-171.9232 384-384s-171.9232-384-384-384-384 171.9232-384 384 171.9232 384 384 384z\" p-id=\"2262\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id